import React from "react";
import DashboardCard, { DashboardCardData } from "./dashboard-card";



const dashboardData: DashboardCardData[] = [
    {
        title: "Pending Worklist",
        value: 12,
        description: "Items to process",
        isDestructive: false
    },
    {
        title: "Stock Requests",
        value: 5,
        description: "Awaiting approval",
        isDestructive: false
    },
    {
        title: "Expiring Soon",
        value: 3,
        description: "Within 30 days",
        isDestructive: true
    },
    {
        title: "Non-Moving Stock",
        value: 8,
        description: "No recent activity",
        isDestructive: false
    }
];

const Component: React.FC = () => {
    return (
        <div className="flex flex-col items-start justify-start p-4 gap-y-2">
            <h3 className="font-semibold text-2xl">Pharmacy Technician Dashboard</h3>
            <h4 className="text-base text-gray-400">Manage stock, track inventory, and monitor expiry dates</h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 w-full">
                {dashboardData.map((data, index) => (
                    <DashboardCard key={index} {...data} />
                ))}
            </div>
        </div>
    );
};

export default Component;